import $api from '../services';

export default {
    getProfile() {
        return $api.get('/profile');
    },
    updateInstructorInformation(params) {
        return $api.put('/profile/instructor-information', params);
    },
    updatePassword(params) {
        return $api.put('/profile', params);
    },
    uploadCoverPhoto(params) {
        return $api.put('/profile/avatar', params);
    },
    getRemindersSettings() {
        return $api.get('profile/reminders');
    },
    setRemindersSettings(params) {
        return $api.post('profile/reminders', params);
    }
};
